var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSea03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 234,
    viewBox: "0 0 351 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0234375,
    y: 0.53125,
    width: 350,
    height: 233,
    fill: "#33837E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M280.73 93.3762L279.036 91.6822C278.1 90.7467 276.508 90.8225 275.478 91.8516L204.671 162.659C203.642 163.688 203.566 165.281 204.501 166.217L206.195 167.911C207.131 168.846 208.724 168.77 209.753 167.741L280.56 96.9335C281.589 95.9044 281.665 94.3118 280.73 93.3762Z",
    fill: "#FFEFEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M280.73 93.3762L279.036 91.6822C278.1 90.7467 276.508 90.8225 275.478 91.8516L270.397 96.9335L275.478 102.015L280.56 96.9335C281.589 95.9044 281.665 94.3118 280.73 93.3762Z",
    fill: "#FFF9F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M228.817 148.679L233.981 133.351L257.723 109.609L262.805 114.691L228.817 148.679Z",
    fill: "#4E2417"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M210.154 92.8086L227.094 109.748L223.877 112.965C223.486 113.356 222.853 113.356 222.463 112.965L206.937 97.4399C206.547 97.0494 206.547 96.4162 206.937 96.0257L210.154 92.8086Z",
    fill: "#FF6737"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M260.973 143.629L277.912 160.569L274.695 163.786C274.305 164.176 273.672 164.176 273.281 163.786L257.756 148.26C257.365 147.87 257.365 147.237 257.756 146.846L260.973 143.629Z",
    fill: "#F9EDE9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M227.094 109.754L260.957 143.617L257.739 146.834C257.349 147.224 256.716 147.224 256.325 146.834L223.877 114.385C223.486 113.995 223.486 113.362 223.877 112.971L227.094 109.754Z",
    fill: "#F1B09B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M274.484 96.2422C274.484 96.2422 277.059 127.682 260.95 143.69L277.872 160.613C296.591 141.895 293.203 114.96 274.484 96.2422Z",
    fill: "#FF6737"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M274.483 96.2387C255.764 77.5204 228.814 74.1494 210.112 92.8507L227.035 109.773C243.026 93.6469 274.483 96.2387 274.483 96.2387Z",
    fill: "#F1B09B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M241.4 80.4556C253.111 81.0716 264.881 86.6353 274.485 96.2385C274.485 96.2385 261.499 95.1686 247.972 98.681C242.952 90.79 241.499 83.2428 241.4 80.4556Z",
    fill: "#F2C3B4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M290.324 129.284C289.676 117.574 284.08 105.82 274.45 96.2427C274.45 96.2427 275.556 109.226 272.081 122.761C279.985 127.76 287.537 129.193 290.324 129.284Z",
    fill: "#FF8C67"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.945 126.681L227.039 109.775C232.776 103.989 240.499 100.608 248.045 98.6515C261.532 95.1542 274.453 96.2059 274.453 96.2059L259.207 111.452L254.106 116.553L274.471 96.2532C274.557 97.3687 276.765 127.972 260.934 143.67L260.9 143.636L243.93 126.696L243.945 126.681ZM274.471 96.2532L274.486 96.2388L274.469 96.2218C274.469 96.2218 274.47 96.2324 274.471 96.2532Z",
    fill: "#F9EDE9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M248.044 98.6533C261.531 95.156 274.452 96.2077 274.452 96.2077L259.206 111.453L248.044 98.6533Z",
    fill: "#FFF8F5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M272.007 122.61C275.504 109.123 274.452 96.2024 274.452 96.2024L259.207 111.448L272.007 122.61Z",
    fill: "#FFF8F5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 308.366,
    cy: 89.9952,
    r: 10.792,
    fill: "#FF6737"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSea03);
export default __webpack_public_path__ + "static/media/sea_03.22a92e3c4d472e88f07b33ec16bec44c.svg";
export { ForwardRef as ReactComponent };